import { useEffect, useRef, useState } from "react";
import {ReactComponent as Bars3Icon} from "./icons/three-bars.svg";
import {ReactComponent as XMarkIcon} from "./icons/cross.svg";
import {ReactComponent as NewChatIcon} from "./icons/chat.svg";
import { ParentProps } from "./interface";

export default function Navbar({ handleHistoryID, histories, historyID, chatWindowMinimized }: ParentProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  let [title, setTitle] = useState<string>();
  const textRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);
  // State to keep track of the clicked button index
  const [clickedButtonIndex, setClickedButtonIndex] = useState<number | null>(
    null
  );

  // Function to get the background color
  const getBackgroundColor = (index: number | string) => {
    return historyID === index ? "#7F26D3" : "white";
  };

  // Function to get the text color
  const getTextColor = (index: number | string) => {
    return historyID === index ? "white" : "black";
  };

  useEffect(() => {
    const { current } = textRef;
    if (current) {
      setIsTruncated(current.scrollWidth > current.clientWidth);
    }
  }, [title]);

  return (
    // <div className="pt-1 " style={{ backgroundColor: "#9D00F9" }}>
    <header
      className="bg-white inset-x-0 drop-shadow-lg absolute  "
      style={{ zIndex: '1' }}
    >
      <nav className="flex items-center justify-between   lg:px-8" aria-label="Global">
        <div className={`flex ${chatWindowMinimized ? 'flex' : 'lg:hidden'} `}>
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div className="flex justify-center text-xl lg:flex-1 lg:justify-start lg:flex-grow  font-bold">
          {/* <p className="-m-1.5 p-1.5 text-purple-800">
              Conversational AI
            </p> */}
        </div>
        <div>
          {/* Empty div is used so that the "Conversational AI" dev is aligned at center in case 
          of large screen because the parent div uses justiy-between property. */}
        </div>
      </nav>
      {mobileMenuOpen && (
        <div
          className={`${chatWindowMinimized ? 'block' : 'lg:hidden'}`}
          // open={mobileMenuOpen}
          // onClose={setMobileMenuOpen}
        >
          <div className="fixed inset-0" />
          <div
            className="fixed inset-y-0 left-0 w-full h-[78vh] overflow-y-auto bg-white px-6 py-6 rounded-md shadow-xl sm:w-full sm:ring-1 sm:ring-gray-900/10"
            // style={{ height: '30vh' }}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-lg font-bold text-black" style={{ marginTop: '15px' }}>
                  Recent Chats
                </p>
              </div>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>

            <div className="mt-6  flow-root">
              <div className="-my-6 divide-y divide-gray-500/10">
                <div className="space-y-2 py-2 w-full  overflow-y-auto overflow-x-hidden ">
                  {histories.map(item => (
                    <button
                      key={item.conversation_id}
                      onClick={() => {
                        handleHistoryID(item.conversation_id);
                        setMobileMenuOpen(false);
                      }}
                      className={` text-left bg-${getBackgroundColor(
                        item.conversation_id
                      )} truncate w-full rounded-md block px-4 py-1 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50`}
                      style={{
                        backgroundColor: getBackgroundColor(item.conversation_id),
                        color: getTextColor(item.conversation_id),
                      }}
                    >
                      {item.conversation_title}
                    </button>
                  ))}
                </div>
                <div className="p-1 rounded-md mb-2" style={{ backgroundColor: '#dfdfdf' }}>
                  <button
                    onClick={() => {
                      handleHistoryID(-1);
                      setMobileMenuOpen(false);
                    }}
                    className="flex items-center gap-2 rounded-lg  text-base font-semibold leading-7 text-gray-900"
                  >
                    <div className="">
                      <NewChatIcon />
                    </div>
                    <p className="m-0 p-0">Start new chat</p>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
    // </div>
  );
}
